import request from "./request";

export default {
  async getProducts(data) {
    return await request.get("products", data, false);
  },
  async getTemplate(name) {
    return await request.get("jsontemplate/" + name, {}, false);
  },
  async updateAutoscheduler(flag) {
    return await request.put("jsontemplate/auto-scheduler", flag, false);
  },
  async getProductTypes() {
    return await request.get("product-types/", {}, false);
  },
  async getProductTypeById(id) {
    return await request.get("product-types/" + id, {}, false);
  },
  async updateProductType(data) {
    return await request.put("product-types", data, false);
  },
  async getStates() {
    return await request.get("states/", {}, false);
  },
  async addProduct(productData) {
    return await request.post("product-types", productData, false);
  },
  async getSmartDriverAppDetails() {
    return await request.get(
      "https://play.google.com/store/apps/details?id=com.sigsenz.smartdriver&hl=en&gl=us&showAllReviews=true&includeTranslatedReviews=true",
      {},
      false
    );
  },
  async getNotifications(pageNumber, groupName) {
    var pageObj = {
      pageSize: 20,
      pageNumber: pageNumber,
      sortOptions: [
        {
          propertyName: "Time",
          orderBy: 1,
        },
      ],
      filterOptions: [
        {
          propertyName: "Groups",
          values: [],
          searchType: 1,
        },
      ],
    };
    groupName.forEach((element) => {
      pageObj.filterOptions[0].values.push(element);
    });
    return await request.post(`notifications`, pageObj, false);
  },
};
